/* Inset entrance: IntersectionObserver → .stack-layer--active; reduced motion activates all. */
(function () {
  /**
   * Click-through: logical index + dir (WeakMap). While dir===1, merge idx with scroll-derived
   * index so wheel/trackpad to the last slide still flips to backward. Scroll uses offsetTop chain
   * + window.scrollTo (scrollIntoView is unreliable on stacked sticky siblings).
   */
  var stackNavByWrapper = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function activateAll(layers) {
    layers.forEach(function (el) {
      el.classList.add('stack-layer--active');
    });
  }

  function layerIsDisplayed(el) {
    if (!el || !el.isConnected) return false;
    var st = window.getComputedStyle(el);
    return st.display !== 'none' && st.visibility !== 'hidden';
  }

  function offsetTopDoc(el) {
    var y = 0;
    var n = el;
    while (n) {
      y += n.offsetTop;
      n = n.offsetParent;
    }
    return y;
  }

  function slideIndexFromScroll(visible) {
    var probe = window.scrollY + window.innerHeight * 0.12;
    var i;
    var t;
    for (i = visible.length - 1; i >= 0; i--) {
      t = offsetTopDoc(visible[i]);
      if (probe + 2 >= t) {
        return i;
      }
    }
    return 0;
  }

  function scrollToSlide(visible, index, instant) {
    var wrapper = visible[0].closest('[data-scroll-stack]');
    var wrapperTop = offsetTopDoc(wrapper);
    var layerHeight = wrapper.offsetHeight / visible.length;
    var y = wrapperTop + index * layerHeight;
    window.scrollTo({ top: Math.max(0, y), behavior: instant ? 'auto' : 'smooth' });
  }

  function getStackNavState(wrapper) {
    var s = stackNavByWrapper.get(wrapper);
    if (!s) {
      s = { idx: null, dir: 1 };
      stackNavByWrapper.set(wrapper, s);
    }
    return s;
  }

  function setupClickZones(wrapper) {
    if (!wrapper || wrapper.dataset.scrollStackClickZones === 'true') return;
    wrapper.dataset.scrollStackClickZones = 'true';

    wrapper.addEventListener('click', function (e) {
      var btn = e.target.closest('.stack-layer__click-zone--advance');
      if (!btn || !wrapper.contains(btn)) return;

      var layers = Array.prototype.slice.call(wrapper.querySelectorAll('[data-stack-layer]'));
      var visible = layers.filter(layerIsDisplayed);
      if (!visible.length) return;

      var hitLayer = btn.closest('[data-stack-layer]');
      if (!hitLayer || !wrapper.contains(hitLayer)) return;

      var last = visible.length - 1;
      if (last < 1) return;

      var st = getStackNavState(wrapper);
      var scrollI = slideIndexFromScroll(visible);
      if (st.dir === 1) {
        if (st.idx === null || st.idx < 0 || st.idx > last) {
          st.idx = scrollI;
        } else {
          st.idx = Math.max(st.idx, scrollI);
        }
      } else {
        if (st.idx === null || st.idx < 0 || st.idx > last) {
          st.idx = scrollI;
        }
      }

      var i = st.idx | 0;
      var targetIdx;
      var branch;

      if (st.dir === 1) {
        if (i < last) {
          targetIdx = i + 1;
          branch = 'next';
        } else {
          targetIdx = i - 1;
          branch = 'prev';
          st.dir = -1;
        }
      } else {
        if (i > 0) {
          targetIdx = i - 1;
          branch = 'prev';
        } else {
          targetIdx = 1;
          branch = 'next';
          st.dir = 1;
        }
      }

      if (targetIdx < 0 || targetIdx > last) return;

      st.idx = targetIdx;

      var nextLabel = wrapper.dataset.scrollLabelNext || '';
      var prevLabel = wrapper.dataset.scrollLabelPrev || '';
      btn.setAttribute('aria-label', branch === 'prev' ? prevLabel : nextLabel);

      var instant = prefersReducedMotion();
      e.preventDefault();
      scrollToSlide(visible, targetIdx, instant);
    });
  }

  function activateLayersInViewport(layers) {
    layers.forEach(function (el) {
      if (!layerIsDisplayed(el)) return;
      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        el.classList.add('stack-layer--active');
      }
    });
  }

  function observeLayers(layers) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('stack-layer--active');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px 12% 0px',
        threshold: [0, 0.15, 0.25],
      }
    );
    layers.forEach(function (el) {
      if (el.dataset.scrollStackObserved === 'true') return;
      el.dataset.scrollStackObserved = 'true';
      io.observe(el);
    });
  }

  function initScrollStack(root) {
    var scope = root && root.nodeType ? root : document;
    var layers = scope.querySelectorAll('[data-stack-layer]');
    if (!layers.length) return;
    var list = Array.prototype.slice.call(layers);

    var seenWrappers = [];
    list.forEach(function (layer) {
      var w = layer.closest('[data-scroll-stack]');
      if (!w || seenWrappers.indexOf(w) !== -1) return;
      seenWrappers.push(w);
      setupClickZones(w);
    });

    if (prefersReducedMotion()) {
      activateAll(list);
      return;
    }
    activateLayersInViewport(list);
    observeLayers(list);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initScrollStack(document);
    });
  } else {
    initScrollStack(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (t && t.id && t.id.indexOf('shopify-section-') === 0) {
      initScrollStack(t);
    }
  });
})();
